import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getEmbeddable } from 'modules/embeddables/actions';
import CallCardWithTables from 'routes/Embed/CallForImpact/CardWithTables';
import CallCarousel from 'routes/Embed/CallForImpact/Carousel';

function EmbedMain(props) {
  const { match: { params: { id } } } = props;

  const [embed, setEmbed] = useState(null);

  useEffect(() => {
    getEmbeddable(id)
      .then((response) => {
        setEmbed(response);
      });
  }, []);

  if (!embed) {
    return null;
  }

  const printCallForImpactCarousel = () => {
    const ids = [];
    const impactNetworks = [];

    if (embed.extra_info.selection_type === 'ids') {
      embed.extra_info.ids.forEach((call) => {
        ids.push(call.id);
      });
    } else {
      embed.extra_info.impact_networks.forEach((impactNetwork) => {
        impactNetworks.push(impactNetwork.id);
      });
    }

    return (
      <CallCarousel
        ids={ids}
        impactNetworks={impactNetworks}
        callUrl={embed.extra_info.call_url}
        embedId={embed.id}
      />
    );
  };

  const printCallForImpactTableWithCards = () => {
    return (
      <CallCardWithTables
        id={embed.extra_info.call_for_impact.id}
        tableUrl={embed.extra_info.table_url}
        callUrl={embed.extra_info.call_url}
        embedId={embed.id}
      />
    );
  };

  switch (embed.mode.id) {
    case 21284853:
      return printCallForImpactCarousel();
    case 21284854:
      return printCallForImpactTableWithCards();
    default:
      return null;
  }
}

EmbedMain.propTypes = {
  match: PropTypes.object.isRequired,
};

export default EmbedMain;



// WEBPACK FOOTER //
// ./src/routes/Embed/Main/components/index.jsx